import { ticketComponent } from './ticket.component';
import { TicketService } from './ticket.service';

export const ticketStateName = 'app.ticket';

export const ticketState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: ticketStateName,
    url: '/tickets/:ticketId?product',
    component: ticketComponent.name,
    data: { requiresAuth: true },
    resolve: {
      aidRequest: TicketService.aidRequest(),
      ticketId: TicketService.ticketId(),
    },
  });
};
